import React, { useEffect } from "react";
import "./App.css";
import "./index.css";
import "./components/common_components/common_css/common_css.css";

import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Login_Signup from "./components/login_signup/Login_Signup";
import Sidebar from "./components/sidebar/Sidebar";
import My_Account from "./components/sidebar_components/my_account/My_Account";
import Deposit from "./components/sidebar_components/deposit/Deposit";
import Withdrawal from "./components/sidebar_components/withdrawal/Withdrawal";
import About_Profile from "./components/about_profile/About_Profile";
import Privacy from "./components/privacy/Privacy";
import Risk_Disclosure from "./components/risk_disclosure/Risk_Disclosure";
import Complaints_Handling_Policy from "./components/Complaints_Handling_Policy/Complaints_Handling_Policy";
import Legal_Documents from "./components/legal_documents/Legal_Documents";
import Security_Instructions from "./components/security_instructions/Security_Instructions";
import Preventing_Money_Laundering from "./components/preventing_money_laundering/Preventing_Money_Laundering";
import Transaction_History from "./components/sidebar_components/transaction_history/Transaction_History";
import Market_News from "./components/sidebar_components/market_news/Market_News";
import Performance from "./components/sidebar_components/performance/Performance";
import Settings from "./components/sidebar_components/settings/Settings";
import ScrollToTop from "./components/scrolltotop/ScrollToTop";
import Trade_Layout from "./components/trade_main/trade_layout/Trade_Layout";
import Verify_Email from "./components/verify_email/Verify_Email";
import Set_New_Password from "./components/set_new_password/Set_New_Password";
import Refer_and_Earn from "./components/sidebar_components/refer_and_Earn/Refer_and_Earn";

function App() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />

      {location.pathname !== "/login" &&
        location.pathname !== "/verify-email" &&
        location.pathname !== "/set-new-password" && <Header />}

      <Routes>
        <Route path="/" element={<Navigate to="/trade" />} />
        <Route path="/login" element={<Login_Signup />} />
        <Route path="/verify-email" element={<Verify_Email />} />
        <Route path="/set-new-password" element={<Set_New_Password />} />
      </Routes>

      {location.pathname !== "/login" &&
        location.pathname !== "/verify-email" &&
        location.pathname !== "/set-new-password" && (
          <div className="body_container">
            {location.pathname !== "/trade" && (
              <section className="dashboard_layout">
                <div className="">
                  <div className="row">
                    <div className="col-xl-2 col-lg-3 col-md-3">
                      {location.pathname !== "/login" &&
                        location.pathname !== "/trade" &&
                        location.pathname !== "/verify-email" &&
                        location.pathname !== "/set-new-password" && (
                          <Sidebar />
                        )}
                    </div>

                    <div className="col-xl-10 col-lg-9 col-md-12">
                      <div
                        className={
                          location.pathname !== "/login" &&
                          location.pathname !== "/verify-email" &&
                          location.pathname !== "/set-new-password"
                            ? "section_box"
                            : ""
                        }
                      >
                        <Routes>
                          <Route path="/my-account" element={<My_Account />} />
                          <Route path="/deposit" element={<Deposit />} />
                          <Route path="/withdrawal" element={<Withdrawal />} />
                          <Route
                            path="/about-profile"
                            element={<About_Profile />}
                          />
                          <Route
                            path="/privacy-agreement"
                            element={<Privacy />}
                          />
                          <Route
                            path="/risk-disclosure"
                            element={<Risk_Disclosure />}
                          />
                          <Route
                            path="/complaints-handling-policy"
                            element={<Complaints_Handling_Policy />}
                          />
                          <Route
                            path="/legal-documents"
                            element={<Legal_Documents />}
                          />
                          <Route
                            path="/security-instructions"
                            element={<Security_Instructions />}
                          />
                          <Route
                            path="/preventing-money-laundering"
                            element={<Preventing_Money_Laundering />}
                          />
                          <Route
                            path="/transaction-history"
                            element={<Transaction_History />}
                          />
                          <Route
                            path="/market-news"
                            element={<Market_News />}
                          />
                          <Route
                            path="/performance"
                            element={<Performance />}
                          />
                          <Route path="/settings" element={<Settings />} />
                          <Route
                            path="/refer-and-earn"
                            element={<Refer_and_Earn />}
                          />
                        </Routes>
                        {location.pathname !== "/login" &&
                          location.pathname !== "/verify-email" &&
                          location.pathname !== "/trade" &&
                          location.pathname !== "/set-new-password" && (
                            <Footer />
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            <section className="trade_layout_section">
              <Routes>
                <Route path="/trade" element={<Trade_Layout />} />
              </Routes>
            </section>
          </div>
        )}
    </>
  );
}

export default App;
